import React from "react";
import { useTranslation } from "react-i18next";
import "./index.css";
import LCAResultsHeader from "./Header";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";
import LCAResultsContent from "./LCAResultsContent";

const ProdLCAResults48Components = ({ productId }) => {
  const { t } = useTranslation();
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });

  return (
    <div className="lca-results-48-container" id="lca-results-48-id">
      <LCAResultsHeader productId={productId} show={show} />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <div className="lca-results-48-content">
          <LCAResultsContent productId={productId} />
        </div>
      )}
    </div>
  );
};

export default ProdLCAResults48Components;

